import { connect } from 'react-redux';

import ShippingPolicy from '../components/pages/shipping-policy';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const ShippingPolicyConnector = connect(mapStateToProps, mapDispatchToProps)(ShippingPolicy);

export default ShippingPolicyConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/shipping-policy-connector.js
 **/